// types
import { TP_Building } from './types'
// components
import { ChildrenViewBySchema } from './ChildrenViewBySchema'
import { isParameterApp } from '../../../parameterApps';
import { Banner } from 'baseui/banner';
import { StyledLink } from 'baseui/link';
import { KIND } from 'baseui/toast';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { GetObjectUrl } from '../../../../utils/navigationService';
import { useStyletron } from 'styletron-react';
import OnboardingView from './Onboarding/OnboardingView';


export function OperatorPanel(props: TP_Building) {

    const [css] = useStyletron();
    return (
        <>
            {props.isOnboarding && <OnboardingView showFinishButton={true} {...props}></OnboardingView>}
            {props.squereMeter === 0 &&
                <Banner kind={KIND.warning}>
                    <FormattedMessage id="P_Building.NoSquereMeter" defaultMessage="The square meter configuration for the building is missing." />
                    <span> </span>
                    <Link to={`${GetObjectUrl(props.resourceGroupId, props.id)}?defaultView=configuration`} className={css({ textDecoration: 'none' })}>
                        <StyledLink animateUnderline ><FormattedMessage id="configuration" defaultMessage="Configuration" /></StyledLink>
                    </Link>
                </Banner>}
            <ChildrenViewBySchema filter={(app) => !isParameterApp(app.schema)} resourceGroupId={props.resourceGroupId} parentId={props.id} defaultGroup={props.showGroupInOP} />
        </>

    );
}
